import { TimeRangeTypes } from "@enums/time-range-types";
import { SelectOption } from "@idw-types/common";
import { LabelWidthTypes } from "@enums/label-width-types";
import { LayoutTypes } from "@enums/layout-types";
import { DateInputFormGroup } from "../date-input-form-group/date-input-form-group";
import { SearchFormFilterRow } from "../search-form-filter-row/search-form-filter-row";
import { TimeRangeSelectFormGroup } from "../select-form-groups/time-range-select-form-group";

type TimeRangeSearchFormFilterRowProps = {
    idPrefix: string;
    labelWidth: LabelWidthTypes;
    selectedTimeRange: SelectOption;
    startDate: Date;
    endDate: Date;
    timeRangeTypes: Array<TimeRangeTypes>;
    minDate: Date;
    maxDate: Date;
    showMonthDropdown: boolean;
    showYearDropdown: boolean;
    showMonthYearPicker: boolean;
    showTimeSelect?: boolean;
    layout: LayoutTypes;
    startDateLabel: string;
    startDateAriaLabel: string;
    endDateLabel: string;
    endDateAriaLabel: string;
    dateFormat: string;
    onChangeTimeRange: (timeRangeOption: SelectOption) => void;
    onChangeStartDate: (newDate: Date) => void;
    onChangeEndDate: (newDate: Date) => void;
    leftComponent?: React.ReactNode;
};

export const TimeRangeSearchFormFilterRow = (props: TimeRangeSearchFormFilterRowProps) => {
    const {
        idPrefix,
        labelWidth,
        selectedTimeRange,
        startDate,
        endDate,
        timeRangeTypes,
        minDate,
        maxDate,
        showMonthDropdown,
        showYearDropdown,
        showMonthYearPicker,
        showTimeSelect,
        layout,
        startDateLabel,
        startDateAriaLabel,
        endDateLabel,
        endDateAriaLabel,
        dateFormat,
        onChangeTimeRange,
        onChangeStartDate,
        onChangeEndDate,
        leftComponent
    } = props;

    return (
        <SearchFormFilterRow>
            {leftComponent ? leftComponent: null}
            <TimeRangeSelectFormGroup
                disabled={false}
                idPrefix={`${idPrefix}`}
                isClearable={false}
                isSearchable={false}
                isRequired={false}
                labelWidth={labelWidth}
                layout={layout}
                onChange={onChangeTimeRange}
                selectedOption={selectedTimeRange}
                timeRangeTypes={timeRangeTypes}
            />
            <DateInputFormGroup
                controlId={`${idPrefix}-start-date-input`}
                automationId={`${idPrefix}-start-date-input`}
                labelWidth={labelWidth}
                label={startDateLabel}
                ariaLabel={startDateAriaLabel}
                disabled={selectedTimeRange.value !== TimeRangeTypes.CUSTOM}
                isRequired={true}
                layout={layout}
                minDate={minDate}
                maxDate={endDate || maxDate}
                dateFormat={dateFormat}
                value={startDate}
                onChange={onChangeStartDate}
                shouldCloseOnSelect={true}
                showMonthDropdown={showMonthDropdown}
                showYearDropdown={showYearDropdown}
                showMonthYearPicker={showMonthYearPicker}
                showTimeSelect={showTimeSelect}
            />
            <DateInputFormGroup
                controlId={`${idPrefix}-end-date-input`}
                automationId={`${idPrefix}-end-date-input`}
                labelWidth={labelWidth}
                label={endDateLabel}
                ariaLabel={endDateAriaLabel}
                disabled={selectedTimeRange.value !== TimeRangeTypes.CUSTOM}
                isRequired={true}
                layout={layout}
                minDate={startDate || minDate}
                maxDate={maxDate}
                dateFormat={dateFormat}
                value={endDate}
                onChange={onChangeEndDate}
                shouldCloseOnSelect={true}
                showMonthDropdown={showMonthDropdown}
                showYearDropdown={showYearDropdown}
                showMonthYearPicker={showMonthYearPicker}
                showTimeSelect={showTimeSelect}
            />
        </SearchFormFilterRow>
    );
};